import React, { useEffect , useState } from "react";
import { Slider, TextField,makeStyles } from "@material-ui/core";
import axios from "axios";
import { NODE_API_URL } from "../../../../../../env_config";
import Cookies from "js-cookie";
// import { Field } from "formik";
// import {toAbsoluteUrl} from "../../../../_helpers";
// import SVG from "react-inlinesvg";
// import {OverlayTrigger,Tooltip} from "react-bootstrap";

const useStyles = makeStyles({
    TextField: {
      width: 80,
      margin:0
    },
  });

export const PriceFancy = ({formik,naturalFancyData,language,location}) => {
    const classes = useStyles();
    const [minPrice, setMinPrice] = useState(location && location.Formik && typeof (location.Formik.minPrice) === "number"?location.Formik.minPrice:naturalFancyData.length !== 0 && naturalFancyData[0].total_price_from !== null ? naturalFancyData[0].total_price_from : 0);
    const [maxPrice, setMaxPrice] = useState(location && location.Formik && typeof (location.Formik.maxPrice) === "number"?location.Formik.maxPrice:naturalFancyData.length !== 0 && naturalFancyData[0].total_price_to !== null ? naturalFancyData[0].total_price_to : 99999);
    const [priceRangeValue, setPriceRangeValue] = useState([location && location.Formik && typeof (location.Formik.minPrice) === "number"?location.Formik.minPrice:naturalFancyData.length !== 0 && naturalFancyData[0].total_price_from !== null ? naturalFancyData[0].total_price_from : 0, location && location.Formik && typeof (location.Formik.maxPrice) === "number"?location.Formik.maxPrice:naturalFancyData.length !== 0 && naturalFancyData[0].total_price_to !== null ? naturalFancyData[0].total_price_to : 99999]);
    // const minPriceRange = naturalFancyData.length !== 0 && naturalFancyData[0].total_price_from !== null ? naturalFancyData[0].total_price_from : 0;
    // const maxPriceRange = naturalFancyData.length !== 0 && naturalFancyData[0].total_price_to !== null ? naturalFancyData[0].total_price_to : 99999;
    const [minPriceRange,setminPriceRange] = useState(0)
    const [maxPriceRange,setmaxPriceRange] = useState(99999)
    useEffect(() => {
        // formik.setFieldValue("minPrice", minPrice);
        // formik.setFieldValue("maxPrice", maxPrice);
        if(naturalFancyData && naturalFancyData.length){
            const parentDomain = new URL(document.referrer || "http://localhost:3000/").origin
            axios({
                method: "POST",
                url: `${NODE_API_URL}/iframe/fetchPriceRanges`,
                headers: { "Content-Type": "application/json","Parent-Domain":parentDomain },
                data: {
                    "user_id":naturalFancyData[0].user_id,
                    "rule_id":naturalFancyData[0].rule_id,
                    token:localStorage.getItem("auth")
                },
            })
            .then(res => {
                if(res && res.data){
                    if(location && location.Formik && typeof (location.Formik.minPrice) === "number" && location && location.Formik && typeof (location.Formik.maxPrice) === "number"){
                        formik.setFieldValue("minPrice", location.Formik.minPrice);
                        formik.setFieldValue("maxPrice", location.Formik.maxPrice);
                        setPriceRangeValue([location.Formik.minPrice,location.Formik.maxPrice])
                    }
                    else{
                        formik.setFieldValue("minPrice", res.data.minprice);
                        formik.setFieldValue("maxPrice", res.data.maxprice);
                        setPriceRangeValue([res.data.minprice,res.data.maxprice])
                    }
                    setminPriceRange(res.data.minprice)
                    setmaxPriceRange(res.data.maxprice)
                }
            })
        }
    }, [naturalFancyData]);

    const handlePriceRangeChange = (event, newValue) => {
        setMinPrice(newValue[0]);
        setMaxPrice(newValue[1]);
        setPriceRangeValue(newValue);
        // formik.setFieldValue("minPrice", newValue[0]);
        // formik.setFieldValue("maxPrice", newValue[1]);
    };

    const handlePriceRangeChangeCommitted = (event, newValue) => {
        formik.setFieldValue("minPrice", newValue[0]);
        formik.setFieldValue("maxPrice", newValue[1]);
    };

    return (
        <>
            <div className="row">
                <div className="col-12 font-size-lg font-weight-bold mb-3">{language.CCMODE_THEME1_SEARCHDIAMOND_PRICE}</div>
                <div className="col-12">
                    <div className="row m-0">
                        <div className="col-md-12">
                            <Slider
                                getAriaLabel={() => "Price Range"}
                                value={priceRangeValue}
                                onChangeCommitted={handlePriceRangeChangeCommitted}
                                onChange={handlePriceRangeChange}
                                step={10}
                                valueLabelDisplay="auto"
                                // getAriaValueText={priceRangeValue}
                                min={minPriceRange}
                                max={maxPriceRange}
                                color="secondary"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-between">
                            <TextField
                                className={classes.TextField}
                                margin="dense"
                                name="minPrice"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={priceRangeValue[0]}
                                color="secondary"
                                type="number"
                                inputProps={{
                                    style: {
                                      padding: 5,
                                      textAlign:"center"
                                    }
                                 }}
                                onChange={(e) => {
                                    setMinPrice(Number(e.target.value));
                                    setPriceRangeValue([
                                        Number(e.target.value),
                                        priceRangeValue[1],
                                    ]);
                                    formik.setFieldValue("minPrice", Number(e.target.value));
                                }}
                            />
                                
                            <TextField
                                className={classes.TextField}
                                margin="dense"
                                variant="outlined"
                                name="maxPrice"
                                InputLabelProps={{ shrink: true }}
                                value={ priceRangeValue[1]}
                                color="secondary"
                                type="number"
                                inputProps={{
                                    style: {
                                      padding: 5,
                                      textAlign:"center"
                                    }
                                 }}
                                onChange={(e) => {
                                    setMaxPrice(Number(e.target.value));
                                    setPriceRangeValue([
                                        priceRangeValue[0],
                                        Number(e.target.value),
                                    ]);
                                    formik.setFieldValue("maxPrice", Number(e.target.value));
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
